var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6873 3.83757L14.5123 3.01258C15.1958 2.32914 16.3038 2.32914 16.9873 3.01258C17.6707 3.69603 17.6707 4.80411 16.9873 5.48756L16.1623 6.31255M13.6873 3.83757L8.13782 9.387C7.7149 9.81 7.41487 10.3398 7.26981 10.9201L6.6665 13.3333L9.07975 12.73C9.66 12.585 10.1898 12.2849 10.6128 11.862L16.1623 6.31255M13.6873 3.83757L16.1623 6.31255",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 11.25C15.8333 13.9895 15.8332 15.3593 15.0767 16.2813C14.9382 16.45 14.7834 16.6048 14.6146 16.7433C13.6927 17.5 12.3228 17.5 9.58325 17.5H9.16667C6.02397 17.5 4.45263 17.5 3.47632 16.5236C2.50002 15.5474 2.5 13.976 2.5 10.8333V10.4166C2.5 7.67706 2.5 6.30728 3.25662 5.38533C3.39514 5.21654 3.54992 5.06177 3.7187 4.92324C4.64066 4.16663 6.01043 4.16663 8.75 4.16663",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0672ce1f406170762327dfb45ce6ca9f.svg";
export { ForwardRef as ReactComponent };